import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { checkAuthentication, logoutUser } from '../redux/actions/authActions';

// Components
import { Header } from '../components';

// Constants
import { BLUE, WHITE, WhiteLogo } from '@wave-engagement/wave-react';

const LOGGED_IN_LINKS = [
  {
    slug: '/home',
    text: 'Home'
  },
  {
    slug: '/leaderboard',
    text: 'Leaderboard'
  },
  {
    slug: '/account',
    text: 'Profile'
  },
  {
    slug: '/photos',
    text: 'My Photos'
  }
];

const LOGGED_OUT_LINKS = [
  {
    slug: '/auth/create-account',
    text: 'Create Account'
  },
  {
    slug: '/auth/login',
    text: 'Login'
  }
];

const AppBar = () => {
  const dispatch = useDispatch();
  const auth = useSelector(state => state.auth);
  const location = useLocation();
  const { pathname } = location;

  useEffect(() => {
    checkAuthentication(dispatch, auth.isFullyAuthenticated);
  }, [dispatch, auth.isFullyAuthenticated]);

  return (
    <Header
      logo={WhiteLogo}
      logoDescription='Wave Engagement Logo'
      links={auth.isFullyAuthenticated ? LOGGED_IN_LINKS : LOGGED_OUT_LINKS}
      backgroundColor={BLUE}
      textColor={WHITE}
      isLoading={auth.isLoading}
      onLogout={auth.isFullyAuthenticated ? () => logoutUser(dispatch) : undefined}
      pathname={pathname}
    />
  );
}
export default AppBar;